import { render, staticRenderFns } from "./event-results-statistics.vue?vue&type=template&id=2e07cb0f&lang=pug"
import script from "./event-results-statistics.vue?vue&type=script&lang=coffee"
export * from "./event-results-statistics.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports